/**
 * Mock talent data for search functionality
 * This file contains sample talent profiles used in the search page
 */

import { Talent } from "../types/search";

/**
 * Mock talent profiles for demonstration purposes
 * In production, this data would come from an API
 */
export const mockTalents: Talent[] = [
  {
    id: "1",
    username: "kimdev",
    name: "김개발",
    title: "Senior Frontend Developer",
    location: "서울, 대한민국",
    experience: 5,
    skills: ["React", "TypeScript", "Next.js", "JavaScript", "HTML/CSS"],
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    currentCompany: "테커 테크",
    companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=60&h=60&fit=crop",
    education: "서울대학교 컴퓨터공학과",
    isAvailable: true,
    lastActive: "2023-10-15",
    projects: 12,
    recommendations: 8,
    hasInternship: false,
    position: "Frontend",
  },
  {
    id: "2",
    username: "leebackend",
    name: "이백엔드",
    title: "Backend Developer",
    location: "부산, 대한민국",
    experience: 3,
    skills: ["Node.js", "Python", "PostgreSQL", "Docker", "AWS"],
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    currentCompany: "스타트업 코리아",
    companyLogo: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=60&h=60&fit=crop",
    education: "부산대학교 소프트웨어공학과",
    isAvailable: true,
    lastActive: "2023-10-14",
    projects: 8,
    recommendations: 5,
    hasInternship: true,
    position: "Backend",
  },
  {
    id: "3",
    username: "parkfullstack",
    name: "박풀스택",
    title: "Full Stack Developer",
    location: "대구, 대한민국",
    experience: 4,
    skills: ["React", "Node.js", "MongoDB", "Express", "TypeScript"],
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    currentCompany: "테크 스타트업",
    companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=60&h=60&fit=crop",
    education: "경북대학교 컴퓨터공학과",
    isAvailable: false,
    lastActive: "2023-10-10",
    projects: 15,
    recommendations: 12,
    hasInternship: false,
    position: "Full Stack",
  },
  {
    id: "4",
    username: "choidevops",
    name: "최데브옵스",
    title: "DevOps Engineer",
    location: "인천, 대한민국",
    experience: 6,
    skills: ["Docker", "Kubernetes", "AWS", "Terraform", "Jenkins"],
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    currentCompany: "클라우드 컴퍼니",
    companyLogo: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=60&h=60&fit=crop",
    education: "인하대학교 컴퓨터공학과",
    isAvailable: true,
    lastActive: "2023-10-16",
    projects: 20,
    recommendations: 15,
    hasInternship: false,
    position: "DevOps",
  },
  {
    id: "5",
    username: "jungmobile",
    name: "정모바일",
    title: "Mobile Developer",
    location: "광주, 대한민국",
    experience: 2,
    skills: ["React Native", "Flutter", "iOS", "Android", "JavaScript"],
    avatar: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=150&h=150&fit=crop&crop=face",
    currentCompany: "모바일 스타트업",
    companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=60&h=60&fit=crop",
    education: "전남대학교 컴퓨터공학과",
    isAvailable: true,
    lastActive: "2023-10-13",
    projects: 6,
    recommendations: 3,
    hasInternship: true,
    position: "Mobile",
  },
  {
    id: "6",
    username: "handata",
    name: "한데이터",
    title: "Data Scientist",
    location: "대전, 대한민국",
    experience: 4,
    skills: ["Python", "Machine Learning", "TensorFlow", "Pandas", "SQL"],
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    currentCompany: "AI 스타트업",
    companyLogo: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=60&h=60&fit=crop",
    education: "KAIST 데이터사이언스학과",
    isAvailable: true,
    lastActive: "2023-10-12",
    projects: 10,
    recommendations: 7,
    hasInternship: false,
    position: "Data Science",
  },
  {
    id: "7",
    username: "shinjunior",
    name: "신입개발",
    title: "Junior Frontend Developer",
    location: "서울, 대한민국",
    experience: 0,
    skills: ["HTML", "CSS", "JavaScript", "React", "Git"],
    avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cfdcb5ab?w=150&h=150&fit=crop&crop=face",
    currentCompany: "신입 개발자",
    companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=60&h=60&fit=crop",
    education: "홍익대학교 컴퓨터공학과",
    isAvailable: true,
    lastActive: "2023-10-11",
    projects: 3,
    recommendations: 1,
    hasInternship: true,
    position: "Frontend",
  },
  {
    id: "8",
    username: "ohsenior",
    name: "오시니어",
    title: "Senior Backend Developer",
    location: "서울, 대한민국",
    experience: 8,
    skills: ["Java", "Spring Boot", "Microservices", "Redis", "PostgreSQL"],
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    currentCompany: "대기업",
    companyLogo: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=60&h=60&fit=crop",
    education: "서울대학교 컴퓨터공학과",
    isAvailable: false,
    lastActive: "2023-10-09",
    projects: 25,
    recommendations: 20,
    hasInternship: false,
    position: "Backend",
  },
];
